import { z } from 'zod';

export const OPERATOR_STATUSES = [
  'UNKNOWN',
  'LOGOUT',
  'OFFLINE',
  'ADMIN',
  'AVAILABLE',
  'CALLING',
] as const;

export const OperatorStatusSchema = z.enum(OPERATOR_STATUSES);
export type OperatorStatus = z.infer<typeof OperatorStatusSchema>;
